import { Component, OnInit } from '@angular/core';
import { StateService } from '../../../core/services/state.service';
import { EconomyService, ValutaItem, TaxItem, PriceListItem } from '../../../services/economy.service';
import { DataTaskService } from '../../../core/services/data-task.service';
import { LogisticService, BusinesscoItem } from '../../../services/logistic.service';

@Component({
    selector: 'tt-price-list',
    templateUrl: './price-list.component.html',
    styleUrls: ['./price-list.component.css'],
})
export class PriceListComponent implements OnInit {
    public priceListId;

    public edit?: Edit;

    public selectListCompanies: BusinesscoItem[] = [];

    public selectListCurrencies: ValutaItem[] = [];

    public selectListTaxes: TaxItem[] = [];

    public selectListPrices: PriceListItem[] = [];

    public saving = false;

    constructor(
        private stateService: StateService,
        private datatask: DataTaskService,
        private logistic: LogisticService,
        private economy: EconomyService,
    ) {
        this.priceListId = this.stateService.getStateParams()['pricelist_id'];
    }

    private async loadEdit() {
        if (!!this.priceListId) {
            this.edit = (await this.datatask.Post(650, { pricelist_id: this.priceListId }))[0];
        }
    }

    private async loadCompanies() {
        this.selectListCompanies = await this.logistic.getCompanies();
    }

    private async loadCurrencies() {
        this.selectListCurrencies = await this.economy.getValutas();
    }

    private async loadTaxes() {
        this.selectListTaxes = await this.economy.getTaxes();
    }

    private async loadPrices() {
        if (!this.edit) return;

        this.selectListPrices = await this.economy.getPriceLists({
            factorbased: '1',
            pricelist_id: this.edit.pricelist_id,
        });
    }

    public async saveChanges() {
        if (!!this.edit) {
            try {
                this.saving = true;

                await this.datatask.Post(660, this.edit);

                this.stateService.back();
            } finally {
                this.saving = false;
            }
        }
    }

    private async init() {
        await this.loadEdit();
        this.loadCompanies();
        this.loadCurrencies();
        this.loadTaxes();
        this.loadPrices();
    }

    ngOnInit() {
        this.init();
    }
}

interface Edit {
    pricelist_id: string;
    pricelist_name: string;
    businessco_no: string;
    pricelist_valuta_id: string;
    tax_keyno: string;
    tax_name: string;
    pricelist_id_new: string;
    pricelist_shortname: string;
    factorbased_is: string;
    factorbased_factor: string;
    factorbased_on_pricelist_id: string;
    pricerise_on_broken_package: string;
    pricerise_pst: string;
    sortorder: string;
    tax_pst: string;
    update_pricelist_when_purchprice_change: string;
}
